import Vue from "vue"

import router from "@/router"
import store from "@/store"

import App from "./App.vue"
import config from "./app.config"

// Import plugins
import i18n from "@/plugins/i18n"
import vuetify from "@/plugins/vuetify"
import generics from "@/plugins/generics"
import "@/plugins/apexchart"
import "@/plugins/gtag"

// Import global sass
import "@/assets/scss/variables.scss"
import CKEditor from "@ckeditor/ckeditor5-vue2"
import '@/assets/styles/mobile-styles.css'

// Enregistrement du Service Worker PWA (prod uniquement)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
} else if ('serviceWorker' in navigator) {
  // En dev : desenregistrer tout SW residuel et purger ses caches
  // pour eviter que le SW de prod cache du vieux code en local.
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister())
  }).catch(() => {})
  if (typeof caches !== 'undefined') {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => {})
  }
}

// Setup application configuration
Vue.prototype.$appConfig = config.general
Vue.config.productionTip = false
Vue.use(CKEditor)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  generics,
  render: h => h(App)
}).$mount("#app")
